// Public Terms of Service page (/terms).
import React from "react";
import { TermsBody } from "./legalContent";

export default function TermsPage() {
  return (
    <div style={{ maxWidth: 820, margin: "0 auto", padding: "32px 20px 64px" }}>
      <h1 style={{ fontSize: 24, color: "#0f172a", marginBottom: 16 }}>Terms of Service</h1>
      <TermsBody />
    </div>
  );
}
